import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import api from '../api';
import { formatData } from '../../providersHelpers';

import Context from './context';

const ProductsTypesProvider = (props) => {
    const { children } = props;
    const [data, setData] = useState({ ids: [], byId: {} });
    const [error, setError] = useState({});
    const get = useCallback(
        () =>
            api
                .get()
                .then((res) => {
                    const dataRes = formatData(res);
                    setData(dataRes);
                    return dataRes;
                })
                .catch(setError),
        []
    );
    return (
        <Context.Provider
            value={{
                get,
                data,
                error
            }}
        >
            {children}
        </Context.Provider>
    );
};

ProductsTypesProvider.propTypes = {
    children: PropTypes.element.isRequired
};

export default ProductsTypesProvider;
